import { render } from "./TableTab.vue?vue&type=template&id=d06f9a64&scoped=true"
import script from "./TableTab.vue?vue&type=script&lang=js"
export * from "./TableTab.vue?vue&type=script&lang=js"

import "./TableTab.vue?vue&type=style&index=0&id=d06f9a64&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d06f9a64"]])

export default __exports__